<template>
  <section class="ibcgp-publications-instagram mb-4">
    <h1 class="h4 text-center font-weight-bold mb-2 ibcgp-publications-instagram-title">
      Publicações no Instagram
    </h1>
    <p class="text-center text-muted small mb-3">
      Acompanhe conteúdos e comunicados do instituto no perfil oficial.
    </p>
    <div class="ibcgp-instagram-frame-wrap">
      <iframe
        :src="embedSrc"
        class="ibcgp-instagram-iframe"
        title="Instagram do IBCGP"
        loading="lazy"
        allowfullscreen
        referrerpolicy="strict-origin-when-cross-origin"
      />
    </div>
    <p class="text-center small mt-2 mb-0">
      <a
        :href="links.instagram"
        target="_blank"
        rel="noopener noreferrer"
        class="text-primary font-weight-bold"
      >
        Abrir @ibcgp no Instagram
      </a>
    </p>
  </section>
</template>

<script>
import links from '../../consts/links.js'

export default {
  name: 'InstagramEmbed',
  data () {
    return { links }
  },
  computed: {
    embedSrc () {
      return this.links.instagramEmbedIframe
    }
  }
}
</script>

<style scoped>
.ibcgp-publications-instagram-title {
  color: #02225b;
}

.ibcgp-instagram-frame-wrap {
  position: relative;
  width: 100%;
  max-width: 540px;
  margin: 0 auto;
  min-height: 480px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(2, 34, 91, 0.1);
  border: 1px solid rgba(2, 34, 91, 0.08);
  background: #fff;
}

.ibcgp-instagram-iframe {
  width: 100%;
  height: 520px;
  border: 0;
  display: block;
}

@media (max-width: 575px) {
  .ibcgp-instagram-iframe {
    height: 480px;
  }
}
</style>
